import { createVNode as a, mergeProps as i } from "vue";
import o from "../node_modules/@pf-ui/pf-icon-svg/es/asn/SettingOutlinedStandard.js";
import d from "../components/PfIcon.js";
const t = (r, e) => {
  const n = {
    ...r,
    ...e.attrs
  };
  return a(d, i(n, {
    icon: o
  }), null);
};
t.displayName = "SettingOutlinedStandard";
t.inheritAttrs = !1;
export {
  t as default
};
